<template>
  <div v-if="!consentGiven && hasTranslation" class="cookie-consent">
    <p>{{ translation.message }}
      <router-link to="/privacy-policy">{{ translation.privacyPolicy }}</router-link>.
    </p>
    <button @click="acceptCookies">{{translation.acceptButton}}</button>
  </div>
</template>

<script>
import { translate } from '../../assets/translations';

export default {
  computed:{
    translation(){
      return translate(this.$store.state.language).cookieConsent;
    },
    hasTranslation(){
      return this.translation.message && this.translation.acceptButton
    }
  },
  data() {
    return {
      consentGiven: false
    };
  },
  mounted() {
    this.checkCookieConsent();
  },
  methods: {
    acceptCookies() {
      localStorage.setItem('cookieConsent', 'accepted');
      this.consentGiven = true;
    },
    checkCookieConsent() {
      const consent = localStorage.getItem('cookieConsent');
      if (consent === 'accepted') {
        this.consentGiven = true;
      }
    }
  }
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #1e3a5f;
  color: white;
  padding: 20px;
  font-size: 12px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
}

.cookie-consent p {
  margin: 0;
  flex: 1;
	text-align: left;
}

.cookie-consent a {
  color: #ffffff;
  text-decoration: underline;
}

.cookie-consent button {
  background-color: #42bc97;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  margin-left: 20px;
  cursor: pointer;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/CookieConsent.vue